export default __webpack_public_path__ + "static/schin-2-6c5fac5be721b7dc89b1efae096bfade.jpg";